import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { EditorialLayout } from '@babylon/medkit'
import { Link, PopOver, Text } from '@babylon/web-platform-ui'
import messages from '../ServiceNotAvailableModal/messages'

interface Props {
  isOpen: boolean
  onClose(): void
}

const ServiceNotAvailableModalUseDnaV2Design = ({ isOpen, onClose }: Props) => {
  const translate = useFormatMessage()

  return (
    <PopOver
      isOpen={isOpen}
      onClose={onClose}
      title={translate(messages.pageTitle)}
    >
      <EditorialLayout>
        <Text textStyle="caption">{translate(messages.pageHeading)}</Text>
        <Text>
          {translate(messages.body1, {
            link: (
              <Link href={translate(messages.body1LinkHref)}>
                {translate(messages.body1LinkText)}
              </Link>
            ),
          })}
        </Text>
        <Text>{translate(messages.body2)}</Text>
        <Text>
          {translate(messages.body3, {
            link: (
              <Link href={translate(messages.body3LinkHref)}>
                {translate(messages.body3LinkText)}
              </Link>
            ),
          })}
        </Text>
      </EditorialLayout>
    </PopOver>
  )
}

export default ServiceNotAvailableModalUseDnaV2Design
